<template>
	<div class="userLogin">
		<div class="ttp">
			<!-- 注册中心 -->
			<div class="login-box" >
				<div class="login-box-header">
					<h2 style="color: #FFFFFF;">{{$t('registor.center')}}</h2>
					
					<div class="langBox">
						<el-select  style="width: 120px;" size="mini" @change="switchLangq(value)" v-model="value" placeholder="Language">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						 </el-select>
					</div>
				
				</div>
                <div class="login-main">
                    <el-form :model="ruleForm" :rules="rules"  ref="ruleForm" label-width="100px" class="demo-ruleForm">
                         <el-form-item :label="$t('other.a459')" >
                            <el-radio-group v-model="activeName2" style="margin-bottom: 30px;">
                            <el-radio-button label="phone">{{$t('other.a460')}}</el-radio-button>
                            <el-radio-button label="mail">{{$t('other.a461')}}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item v-if="activeName2 == 'phone'" :label="$t('other.a462')" >
                            <el-select v-model="areaCode" :placeholder="$t('other.a50')">
                                <el-option
                                v-for="item in distrisAread"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="activeName2 == 'phone'" :label="$t('other.a395')" prop="user.userPhone">
                            <el-input class="input_box" v-model="ruleForm.user.userPhone" :placeholder="$t('other.a438')"></el-input>
                        </el-form-item>

						<el-form-item v-if="activeName2 == 'mail'" :label="$t('other.a463')" prop="user.userEmail">
                            <el-input class="input_box" v-model="ruleForm.user.userEmail" :placeholder="$t('other.a466')"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('other.a464')" prop="password">
                            <el-input class="input_box" type="password" v-model="ruleForm.password" :placeholder="$t('other.a467')"></el-input>
                        </el-form-item>
                        <el-form-item :label="$t('other.a431')" prop="name">
                            <el-input class="input_box" type="password" v-model="secondPws" :placeholder="$t('other.a431')"></el-input>
                        </el-form-item>
                    

						<el-form-item :label="$t('other.a401')" v-if="activeName2 == 'phone'"  prop="emailCode">
                            <el-input class="input_box" v-model="ruleForm.emailCode" :placeholder="$t('other.a468')"></el-input>
                            <div style="position:absolute;right:40px;bottom:0px;font-size: 14px;cursor: pointer;color:red" ><el-button size="mini" type="danger" @click="getemailCode">{{$t('other.a402')}}</el-button></div>
                        </el-form-item>

						<el-form-item :label="$t('other.a401')" v-if="activeName2 == 'mail'"  prop="emailCode">
                            <el-input class="input_box" v-model="ruleForm.emailCode" :placeholder="$t('other.a469')"></el-input>
                            <div style="position:absolute;right:40px;bottom:0px;font-size: 14px;cursor: pointer;color:red" ><el-button size="mini" type="danger" @click="getemailCode">获取邮箱验证码</el-button></div>
                        </el-form-item>
                        <el-form-item :label="$t('other.a465')" prop="user.userName">
                            <el-input class="input_box" v-model="ruleForm.user.userName" :placeholder="$t('other.a470')"></el-input>
                        </el-form-item>

                        <el-form-item :label="$t('other.a434')" prop="user.invitationCode">
                            <el-input class="input_box" v-model="ruleForm.user.invitationCode" :placeholder="$t('other.a471')"></el-input>
                        </el-form-item>
                        
                    </el-form>
                    <div style="display: flex;justify-content: center;align-items: center;">
						<div class="tologin" @click="gotoLogin">{{$t('registor.log')}}</div>
						
					</div>
                    <div style="display: flex;justify-content: center;align-items: center;">
						<el-button class="input-text" type="primary" @click="registoer">{{$t('registor.register')}}</el-button>
					</div>
					
                </div>
			
			</div>
			
			
		</div>
		
		
	</div>
</template>

<script >
	import md5 from 'js-md5';
    import newOrders from '@/api/moudles/newOrders' 
	import {mapState, mapActions , mapMutations} from 'vuex'
	export default{
		data() {
			return{
				emailCode:null,
                activeName2:'phone',
				registor_inputCountID:'',
				countryvalue:null,
				country: [{
					  value: 'CN',
					  label: 'China'
					},{
					  value: 'TH',
					  label: 'Thailand'
				 },{
					  value: 'PH',
					  label: 'Philippines'
				 },{
					  value: 'ID',
					  label: 'Indonesia'
				 },{
					  value: 'TW',
					  label: 'Taiwan'
				 },{
					  value: 'SG',
					  label: 'Singapore'
				 },{
					  value: 'BZ',
					  label: 'Brazil'
				 },{
					  value: 'MY',
					  label: 'Malaysia'
				 },{
					  value: 'VN',
					  label: 'Vietnam'
				 }],
				registor_inputusername:'',
				registor_password:'',
				registo_comfirPws:'',
				registor_invitationCode:'',
				inputCount: '' ,
				inputPassword:'',
                areaCode:'+86',
				partnerId:null,
				start_time:'',
				end_time:'',
				options: [{
						value: 'zh',
						label: '中文'
					}, {
						value: 'en',
						label: 'English'
				 }],
                 distrisAread:[{
                        value: '+86',
                        label: 'China(+86)'
                    },{
                        value: '+63',
                        label: 'Philippines(+63)'
				 }, {
                        value: '+65',
                        label: 'Singapore(+65)'
				 }, {
                        value: '+84',
                        label: 'Vietnam(+84)'
				 },{
                        value: '+60',
                        label: 'Malaysia(+60)'
				 },{
                        value: '+34',
                        label: 'Spain(+34)'
				 },{
                        value: '+62',
                        label: 'Indonesia(+62)'
				 },{
                        value: '+66',
                        label: 'Thailand(+66)'
				 },{
                        value: '+351',
                        label: 'Portugal(+Portugal)'
				 }],
				 value: '',
				 checked:false,
				 islogin:true,
				 phone:'',
                 secondPws:null,
                 ruleForm:{
                    user:{
                        userPhone:null,
                        userName:null,
                        invitationCode:null,
						userEmail:null
                    },
                    emailCode:null,
                    password:null,
                 },
                 rules: {
                    'user.userPhone': [
                        { required: true, trigger: 'blur' },
                       
                    ],
                    'password': [
                        { required: true, trigger: 'blur' },
                       
                    ],
                    'emailCode': [
                        { required: true, trigger: 'blur' },
                       
                    ],
                    'user.userName': [
                        { required: true, trigger: 'blur' },
                       
                    ],
					'user.userEmail': [
                        { required: true, trigger: 'blur' },
                       
                    ],
                   
                }
			}
		},
		computed:{
			...mapState({
				userInfo:state =>state.login.userInfo,
				loginStatus:state =>state.login.loginStatus,
				hasLogin:state =>state.login.hasLogin,
				registorSuccess:state =>state.login.registorSuccess,
			})
		},
		watch:{
			hasLogin(){
				setInterval(() =>{
					this.gotoindex()
				},500)
				
			},
	
			
		},
		
		created(){
			this.checkPartner()
			this.init()
		},
		mounted(){
		    //绑定事件
		     window.addEventListener('keydown',this.keyDown);
		  },
		destroyed(){
			  window.removeEventListener('keydown',this.keyDown,false);
		},
		  
	
		methods:{
			...mapActions('login',[
				'getEmailCode',
				'getRegister'
			]),

			...mapMutations('login', [
				'SWITCH_LANG',
			]),

			//检测登录地址
			checkPartner(){
				let url=location.href
				newOrders
				.getPartnerId({
					url:url
				})
				.then(res => {
				if(res.code === 200 ){
					console.log('desc',res.data)
					if(res.data && res.data.partnerId){
						this.partnerId=res.data.partnerId
					}
				}else{
					this.$message.warning(res.msg)
				}
				})
			},
			
			getemailCode(){
                console.log(this.activeName2)
                if(this.activeName2 == 'phone'){
                    console.log(this.ruleForm)
                    if(!this.ruleForm.user.userPhone){
                        this.$message.warning(this.$t('other.a452'))
                        return
                    }
                    newOrders
                    .getPhoneCode({
                        country:this.areaCode,
                        phone:this.ruleForm.user.userPhone
                    })
                    .then(res => {
                    if(res.code === 200 ){
                    console.log('desc',res.data)
                    this.$message.success(this.$t('other.a440'))
                    }else{
                    this.$message.warning(res.msg)
                    }
                    })
                }else{
					console.log(this.ruleForm)
					if(!this.ruleForm.user.userEmail){
                        this.$message.warning(this.$t('other.a441'))
                        return
                    }

					this.getEmailCode({email:this.ruleForm.user.userEmail})
					
				}
			
				
			},
			registoer(){
				if(this.activeName2 == 'phone'){
					if(!this.ruleForm.user.userPhone){
                    this.$message.warning(this.$t('other.a438'))
                    return
                }

                if(this.ruleForm.password !== this.secondPws){
                    this.$message.warning(this.$t('other.a472'))
                    return
                }

                if(!this.ruleForm.emailCode ){
                    this.$message.warning(this.$t('other.a432'))
                    return
                }

                if(!this.ruleForm.user.userName ){
                    this.$message.warning(this.$t('other.a473'))
                    return
                }

                this.ruleForm.userId=this.ruleForm.user.userPhone
              
                this.ruleForm.user.userId=this.ruleForm.user.userPhone
				this.ruleForm.partnerId=this.partnerId

                let obj=JSON.parse(JSON.stringify(this.ruleForm))

                  obj.password = md5(obj.password + 'seller')

                  obj.user.userPos='SELLER'
                
                console.log('obj',obj)

                newOrders
                .phoneRegister(obj)
                .then(res => {
                if(res.code === 200 ){
                this.$message.success(this.$t('other.a558'))
                setInterval(() =>{
						this.$router.push('/loginPage')
						},1000)
                }else{
                this.$message.warning(res.msg)
                }
                })

				}else if(this.activeName2 == 'mail'){


					if(!this.ruleForm.user.userEmail){
                    this.$message.warning(this.$t('other.a466'))
                    return
					}

					if(!this.ruleForm.password || this.ruleForm.password !== this.secondPws){
						this.$message.warning(this.$t('other.a472'))
						return
					}

					if(!this.ruleForm.emailCode ){
						this.$message.warning(this.$t('other.a432'))
						return
					}

					if(!this.ruleForm.user.userName ){
						this.$message.warning(this.$t('other.a473'))
						return
					}


					this.ruleForm.userId=this.ruleForm.user.userEmail
					this.ruleForm.user.userId=this.ruleForm.user.userEmail
					let obj=JSON.parse(JSON.stringify(this.ruleForm))

					obj.password = md5(obj.password + 'seller')

					obj.user.userPos='SELLER'
					

					this.getRegister(obj).then(res => {
					
					if(res == 'hasSuccess'){
						setInterval(() =>{
						this.$router.push('/loginPage')
						},1000)
					}
				})
					console.log('obj',obj)
				}

			},
			init(){
				let url=location.href
				if(url.indexOf('?') > -1) {
					
					// let code=url.split('?')
					// let ttp=code[1].split('=')[1]
					// console.log('code',ttp)
                    this.ruleForm.user.invitationCode=this.$route.query.invitationCode
				}

				let account=JSON.parse(localStorage.getItem('userCount'))
				if(account){
					this.checked=true
					this.inputCount=account.account
					this.inputPassword=account.passsword
				}else{
					this.checked=false
				}
			},
			keyDown(e){
				if(e.keyCode === 13) {
					this.getLogin()
					
				}
			},
			switchLangq(value){
				this.SWITCH_LANG(value)
				this.$i18n.locale =  value 
				
			},
			gotoLogin(){
				if(this.$route.query.fromh5){
					this.$router.push({
						path:'/loginPage',
						query:{
							invitationCode:this.$route.query.invitationCode,
							fromh5:this.$route.query.fromh5,
						}
					})
				}else{

					this.$router.push('/loginPage')
				}
			},
			
		
		}
	}
</script>

<style lang="scss" scoped>
	
	.userLogin{
			
			// width: 100%;
			// height: 100vh;
			background-color: #fff;
			position: fixed;
            left: 50%;
            right: 0;
            transform: translate(-219px);
			background-repeat:no-repeat; 
			background-size: cover;
			-webkit-background-size: cover;
			-o-background-size: cover;
			background-position: center 0;
			z-index: 2000;

            .tologin{
			color: red;
			cursor: pointer;
			margin-left: 15px;
		}
        
        /deep/ .el-radio-group{
            margin-bottom: 0!important;
        }



        /deep/ .el-form-item{
            margin-bottom: 4px;
        }
		
		.tologin:hover{
			
			color: #66b1ff;
		}
		
		.langBox{
			position: absolute;
			top: 10px;
			right: -130px;
		}
		
		.login-box{
			
			   
			  
			  width: 438px;
			  border-radius: 10px;
			  background: #fff;
			  box-shadow: 0 0 25px #cac6c6;
	
		}

        .input_box{
            width: 300px;
        }
		.login-desc{
	
			width: 600px;
			height: 480px;
			background-color: #333536;
			opacity: 0.8;
			color: #fff;
			border-radius: 10px;
			box-sizing: border-box;
			padding: 20px 20px;
			z-index: -1;
		}
		.login-left,.login-right{
			width: 50%;
		}
		.pic-box{
			display: inline-block;
			width:155px;
			height: 155px;
		}
		
		.ppt{
			display: flex;
			justify-content:space-between;
			margin: 40px 0;
			
		}
		
		.login-title{
		
			font-size: 20px;
			font-weight: bold;
		}
		
		.input-text{
		
			width: 300px;
			margin: 10px 0;
		}
		
		.login-left,.login-right{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	
		.registor{
			width: 80%;
			text-align: right;
			cursor: pointer;
		}
		
		

		
		.login-box-header{
			height: 180px;
			background-image: url(../assets/img/login_01.png);
			background-repeat:no-repeat;
			background-size:100%;
			border-radius: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: relative;
		}
		.login-main{
			// display: flex;
			// flex-direction: column;
			// justify-content: center;
			// align-items: center;
            margin-top:20px
		}
		
		.input-btn{
			width: 200px;
			border-radius: 30px;
			margin: 50px;
		}
		
		.login-item{
			display: inline-block;
			margin: 10px 0;
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
		}
		
		.login-desc-item{
			font-weight: bold;
			line-height: 50px;
			margin-bottom: 20px;
		}
		
		.login .ttp{
			width: 100%;
			display: flex;
			justify-content: space-around;
			box-sizing: border-box;
			margin-top: 10px;
			position: relative;
			
			
		}
		
		.ppt-item{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 50px;
			height: 50px;
		}
	
		 .el-input__inner{
			width: 250px;
			border: none!important;
		}
		 .el-input--mini{
			width: 170px!important;
		}
			
	
		}
		
		
</style>
